module.exports = __webpack_public_path__ + "img/Girl_010004.92d4bf56.png";